export default __webpack_public_path__ + "static/desklocation04-a4b167cd5a46f1d3ba49d2749c4528d6.png";